"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slider.default;
  }
});

var _Slider = _interopRequireDefault(require("./Slider"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Slider/index.js
// module id = 559
// module chunks = 0